import React, { useState, useEffect } from 'react';
import { Container, Text, Spacer, Loading } from "@nextui-org/react";
import { useParams } from "react-router-dom";
import { WorkshopSteps, StepConfig } from "../../components/WorkshopSteps/WorkshopSteps";
import { getWorkflowById } from '../../config/workflowsApi';

const WorkflowDetailsPage = () => {
    const { workflowId } = useParams<{ workflowId: string }>();
    const [config, setConfig] = useState<Record<string, StepConfig> | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchWorkflow = async () => {
            if (!workflowId) return;

            setIsLoading(true);
            setError(null);

            try {
                const data = await getWorkflowById(workflowId);
                // Check if the data has a stateMachine property or is the config directly
                if (data && data.stateMachine) {
                    setConfig(data.stateMachine as Record<string, StepConfig>);
                } else if (data) {
                     setConfig(data as Record<string, StepConfig>);
                } else {
                    setError("Workflow configuration not found.");
                }
            } catch (err) {
                console.error("Error fetching workflow:", err);
                setError("Failed to fetch workflow details.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchWorkflow();
    }, [workflowId]);

    return (
        <Container display="flex" direction="column" css={{ minHeight: "100vh", padding: "20px" }}>
            <Text h3>Workflow Steps: {workflowId}</Text>
            <Spacer y={1} />

            {isLoading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 150px)' }}>
                    <Loading type="points" size="xl" />
                </div>
            ) : error ? (
                <Text color="error">{error}</Text>
            ) : config ? (
                <div style={{ width: '100%', height: 'calc(100vh - 100px)' }}>
                    <WorkshopSteps config={config} />
                </div>
            ) : null}
        </Container>
    );
};

export default WorkflowDetailsPage;
